import React from 'react';
type SectionHeadingProps = {
  eyebrow: string;
  title: React.ReactNode;
  description?: string;
  inverted?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  inverted = false
}: SectionHeadingProps) {
  return <header className="mx-auto max-w-2xl text-center" data-id="element-5">
      <p className={`inline-flex rounded-full px-3 py-1 text-[10px] font-black uppercase tracking-[0.14em] ${inverted ? 'bg-white/10 text-[#f3d6a1]' : 'bg-[#e4eadc] text-[#526954]'}`} data-id="element-6">
        {eyebrow}
      </p>
      <h2 className={`mt-3 text-3xl font-black leading-[1.06] tracking-[-0.045em] sm:text-4xl ${inverted ? 'text-[#fffaf1]' : 'text-[#4b2d24]'}`} data-id="element-7">
        {title}
      </h2>
      {description ? <p className={`mt-4 text-sm leading-6 ${inverted ? 'text-[#fffaf1]/75' : 'text-[#6e5a50]'}`} data-id="element-8">
          {description}
        </p> : null}
    </header>;
}